import { EditButton } from "react-admin";

function CustomEditButton() {
  return <EditButton variant="fieldwire-primary" />;
}

export default CustomEditButton;
